import { useMutation } from "react-query";
import { CreateTechnicalWorkSchedule } from "services/workSchedule";

export default function useCreateTechnicalWorkSchedule() {
  return useMutation(
    (data:any) => CreateTechnicalWorkSchedule(data),
  );
}
